import { useState, useEffect } from "react";
import { useAuth } from "../context/ApiKeyContext";
import { getApiBaseUrl } from "../config";

const API_BASE_URL = getApiBaseUrl();

/**
 * Indica se o usuário tem o produto com regra exec_process atribuída (users_product_rules).
 */
export function useUserHasProduct(productCode) {
  const { token, user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [hasProduct, setHasProduct] = useState(false);

  useEffect(() => {
    if (!token || !user?.user_id || !productCode) {
      setLoading(false);
      setHasProduct(false);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/users/rules/${user.user_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (!res.ok || cancelled) {
          if (!cancelled) setHasProduct(false);
          return;
        }
        const data = await res.json();
        const products = data.products || [];
        const ok = products.some(
          (p) =>
            p.product_code === productCode &&
            (p.rules || []).some(
              (r) =>
                (r.rule_code || "").toLowerCase() === "exec_process" &&
                r.assigned === true,
            ),
        );
        if (!cancelled) setHasProduct(ok);
      } catch {
        if (!cancelled) setHasProduct(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, user?.user_id, productCode]);

  return { loading, hasProduct };
}
